import src from '../assets/4oreplaygolf.png';
import { imageLogo } from './imageLogo';

export const FourePlayGolfLogo = imageLogo({
  src,
  width: 552,
  height: 301,
  alt: '4ore Play Golf',
});
